import { AlertTriangle, Waves, Droplets, Paintbrush, Wrench, HelpCircle, Layers, Zap } from "lucide-react";

export const SEV_META = {
  low: { label: "Low", color: "#94A3B8", bg: "rgba(148,163,184,0.14)" },
  medium: { label: "Moderate", color: "#C5A24A", bg: "rgba(212,168,75,0.14)" },
  high: { label: "High", color: "#EA580C", bg: "rgba(234,88,12,0.14)" },
  critical: { label: "Critical", color: "#B91C1C", bg: "rgba(185,28,28,0.18)" },
};

export const STATUS_META = {
  open: { label: "Open", color: "#EF4444" },
  monitoring: { label: "Monitoring", color: "#C5A24A" },
  resolved: { label: "Resolved", color: "#10B981" },
};

export const TYPE_META = {
  crack: { label: "Crack", icon: Zap },
  spalling: { label: "Spalling", icon: Layers },
  corrosion: { label: "Corrosion", icon: Wrench },
  water_ingress: { label: "Water Ingress", icon: Droplets },
  peeling_paint: { label: "Peeling Paint", icon: Paintbrush },
  efflorescence: { label: "Efflorescence", icon: Waves },
  rebar_exposure: { label: "Rebar Exposure", icon: AlertTriangle },
  other: { label: "Other", icon: HelpCircle },
};

export const prettyType = (t) => (TYPE_META[t]?.label || (t || "").replace(/_/g, " "));

export const ASSET_TYPES = {
  parking: "Parking structure",
  bridge: "Bridge / Overpass",
  building_facade: "Building facade / Balcony",
  loading_dock: "Loading dock / Industrial slab",
  retaining_wall: "Retaining wall",
  tunnel: "Tunnel / Culvert",
  other: "Other concrete structure",
};

export const ASSET_UNITS = {
  parking: { one: "Level", many: "Levels" },
  bridge: { one: "Span", many: "Spans" },
  building_facade: { one: "Elevation", many: "Elevations" },
  loading_dock: { one: "Bay", many: "Bays" },
  retaining_wall: { one: "Section", many: "Sections" },
  tunnel: { one: "Segment", many: "Segments" },
  other: { one: "Area", many: "Areas" },
};

export const assetUnit = (t) => ASSET_UNITS[t] || ASSET_UNITS.other;
